import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconChevronTop, IconChevronBottom } from '@travel-frontend/icons';
import { ActionLink } from '../../primitives/index.js';
export const ExpandButton = /*#__PURE__*/_styled(({
  isExpanded,
  onClick,
  translations,
  className,
  style
}) => {
  return _jsxs(ActionLink, {
    size: "medium",
    bold: true,
    onClick: onClick,
    "data-cy": "expand",
    "data-testid": "expand",
    className: className,
    style: style,
    children: [isExpanded ? translations.showLess : translations.showMore, ' ', isExpanded ? _jsx(IconChevronTop, {}) : _jsx(IconChevronBottom, {})]
  });
}, process.env.NODE_ENV === "production" ? {
  target: "ems1zxm0"
} : {
  target: "ems1zxm0",
  label: "ExpandButton"
})(process.env.NODE_ENV === "production" ? {
  name: "1h3rtzg",
  styles: "align-items:center"
} : {
  name: "1h3rtzg",
  styles: "align-items:center/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkV4cGFuZEJ1dHRvbi5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNRyIsImZpbGUiOiJFeHBhbmRCdXR0b24uanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBqc3ggYXMgX2pzeCwganN4cyBhcyBfanN4cyB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdC9qc3gtcnVudGltZVwiO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgSWNvbkNoZXZyb25Ub3AsIEljb25DaGV2cm9uQm90dG9tIH0gZnJvbSAnQHRyYXZlbC1mcm9udGVuZC9pY29ucyc7XG5pbXBvcnQgeyBBY3Rpb25MaW5rIH0gZnJvbSAnLi4vLi4vcHJpbWl0aXZlcy9pbmRleC5qcyc7XG5leHBvcnQgY29uc3QgRXhwYW5kQnV0dG9uID0gc3R5bGVkKCh7IGlzRXhwYW5kZWQsIG9uQ2xpY2ssIHRyYW5zbGF0aW9ucywgY2xhc3NOYW1lLCBzdHlsZSB9KSA9PiB7XG4gICAgcmV0dXJuIChfanN4cyhBY3Rpb25MaW5rLCB7IHNpemU6IFwibWVkaXVtXCIsIGJvbGQ6IHRydWUsIG9uQ2xpY2s6IG9uQ2xpY2ssIFwiZGF0YS1jeVwiOiBcImV4cGFuZFwiLCBcImRhdGEtdGVzdGlkXCI6IFwiZXhwYW5kXCIsIGNsYXNzTmFtZTogY2xhc3NOYW1lLCBzdHlsZTogc3R5bGUsIGNoaWxkcmVuOiBbaXNFeHBhbmRlZCA/IHRyYW5zbGF0aW9ucy5zaG93TGVzcyA6IHRyYW5zbGF0aW9ucy5zaG93TW9yZSwgJyAnLCBpc0V4cGFuZGVkID8gX2pzeChJY29uQ2hldnJvblRvcCwge30pIDogX2pzeChJY29uQ2hldnJvbkJvdHRvbSwge30pXSB9KSk7XG59KSBgXG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG5gO1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9RXhwYW5kQnV0dG9uLmpzLm1hcCJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});